import eventbus from 'tiny-emitter/instance';
import { TYPE } from '@/constants';
import SelectionBox from '@/core/utils/selectionBox';
import { allowCtrlA, allowEsc } from '../helper';

export default class LabelsMode {
  constructor(app) {
    this.app = app;
    this.setup();
    allowCtrlA(this);
    allowEsc(this);
    return this;
  }

  setup() {
    this.initSelectionBox();
    this.precalculateSeatCenters();
    eventbus.emit('seatmap:lock:hide');
    eventbus.emit('seatmap:labels:show');
  }

  precalculateSeatCenters() {
    this.app.seatmap.seats.forEach((seat) => {
      seat.realPosition = seat.rbox();
    }, this);
    this.app.seatmap.units
      .filter((u) => u.type === TYPE.TABLE)
      .forEach((unit) => {
        unit.seats.forEach((seat) => {
          seat.realPosition = seat.rbox();
        });
      });
  }

  initSelectionBox() {
    this.selectionBox = new SelectionBox(this.app);
    eventbus.emit('seatmap:changemode');
  }

  removeSelectionBox() {
    this.selectionBox.destroy();
    delete this.selectionBox;
  }

  destroy() {
    this.removeSelectionBox();
    eventbus.emit('seatmap:lock:show');
    eventbus.emit(`seatmap:labels:${this.app.showLabels ? 'show' : 'hide'}`);
  }
}
